/**
 * Show the choice on this press. The campaign update is a full redraw,
 * so it runs on the next turn, after the browser has painted.
 */
export function hideMenuNow(menu) {
  menu?.classList.add('status-dropdown__menu--shut');
}

export function commitAfterPaint(commit) {
  setTimeout(commit, 0);
}

export function chooseOnPress(event, apply) {
  if (event.button !== 0) return;
  event.preventDefault();
  event.stopPropagation();
  apply();
}
